import {
  throttledFetch,
  DEFAULT_THROTTLE_PERIOD,
  ThrottleStorageType,
} from "../utils/ThrottleService";
import { STRAPI_COMMUNITY_API_BASE_URL } from "data/constants";
import { buildParams } from "utils/utils";

export async function getAuthHeaders(): Promise<Record<string, string>> {
  return {};
}

const API_BASE = STRAPI_COMMUNITY_API_BASE_URL;
const TAGS_API = `${API_BASE}/tags`;

// Using throttledFetch from ThrottleService with function name support
async function fetchWithHeaders(
  url: string,
  options: RequestInit = {},
  functionName?: string
) {
  return throttledFetch(
    url,
    getAuthHeaders,
    options,
    DEFAULT_THROTTLE_PERIOD,
    ThrottleStorageType.MEMORY,
    functionName
  );
}

export const TagService = {
  async getAll() {
    const params = buildParams({
      "pagination[page]": 1,
      "pagination[pageSize]": 100,
      sort: "title:asc",
    });
    return fetchWithHeaders(`${TAGS_API}?${params}`, {}, "getAll");
  },
};
